import {
	GuidesEnum,
	HomeEnum,
	HealthCardEnum,
	HelpCenterEnum,
	PerksEnum,
	ProfileEnum,
	ConsultProtocolsEnum,
} from './mapRoutesEnum';

export const EARLY_ACCESS_ROUTES: string[] = [
	HomeEnum.HOME_PAGE,
	HomeEnum.EARLY_ACCESS,
	GuidesEnum.SERVICE_NETWORK_HEALTH,
	GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_CITY,
	GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_DISTRICT,
	GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_UF,
	GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_FAVORITE_PLACES_LIST,
	GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_FAVORITE_PLACES_ADD,
	GuidesEnum.SERVICE_NETWORK_HEALTH_FLOW_FAVORITE_PLACES_EDIT,
	GuidesEnum.SERVICE_NETWORK_ODONTO,
	GuidesEnum.SERVICE_NETWORK_ODONTO_FLOW_CITY,
	GuidesEnum.SERVICE_NETWORK_ODONTO_FLOW_DISTRICT,
	GuidesEnum.SERVICE_NETWORK_ODONTO_FLOW_UF,
	HealthCardEnum.HEALTH_CARD,
	HelpCenterEnum.HELP,
	HelpCenterEnum.SEND_MESSAGE,
	PerksEnum.PERKS,
	ProfileEnum.PROFILE,
	ConsultProtocolsEnum.CONSULT_PROTOCOLS,
];
